import { render, staticRenderFns } from "./NotificationActions.vue?vue&type=template&id=4db92cd2&"
import script from "./NotificationActions.vue?vue&type=script&setup=true&lang=ts&"
export * from "./NotificationActions.vue?vue&type=script&setup=true&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports